import React, { useEffect, useState } from "react";
import { Container, Input } from "reactstrap";
import { useHistory } from "react-router-dom";



// images
import Wave from "../../../src/assets/images/wave.png";
import Dummyuser from "../../../src/assets/images/dummy.png";
import { Link } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Welcomegreet = (props) => {
  const { user } = useSelector(({ Login }) => Login);
  const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("I18N_LANGUAGE"));
  const { i18n } = useTranslation()
  console.log("user", user)

  const onChangeLanguage = (e) => {
    const { name, value } = e.target;
    localStorage.setItem(name, value);
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
  }

  return (
    <section className="Welcomegreet_main">
      <Container fluid>
        <div className="dash_header">
          <div className="welcome_msg_dash">
            <h1>
              {props.t("hi")}, <i>{user?.name}</i>{" "}
              <img src={Wave} alt="" className="img-fluid" />
            </h1>
            {/* <p>
              you have
              <a href="javascript:void(0)"> 1 new message</a>
            </p> */}
          </div>

          <div className="header_userside">
            <div className="language-selector-wrap mx-2">
              <Input type="select"
                name="I18N_LANGUAGE"
                value={currentLanguage}
                onChange={onChangeLanguage}
              >
                <option value={"en"}>en</option>
                <option value={"bul"}>bul</option>
              </Input>
            </div>
            <div className="user_profile">
              <div className="user_img">
                <img src={user?.profileImage?.link || Dummyuser} alt="" className="img_fluid" />
              </div>
              <div className="user_content">
                <h4>{user?.name}</h4>
                <p> {`${user?.countryCode} ${user?.mobileNumber}`}</p>
              </div>
            </div>

            <div className="userlogout">
              <Link to="/logout">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="36"
                  viewBox="0 0 34 36"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.8967 1.02481C14.6432 0.800868 15.4318 0.754542 16.1994 0.889531C16.967 1.02452 17.6924 1.33709 18.3177 1.80228C18.9431 2.26747 19.451 2.87241 19.8009 3.5688C20.1509 4.26519 20.3332 5.03376 20.3334 5.81315V30.1865C20.3332 30.9659 20.1509 31.7344 19.8009 32.4308C19.451 33.1272 18.9431 33.7322 18.3177 34.1973C17.6924 34.6625 16.967 34.9751 16.1994 35.1101C15.4318 35.2451 14.6432 35.1988 13.8967 34.9748L3.89671 31.9748C2.86688 31.6659 1.96406 31.0332 1.32218 30.1707C0.680297 29.3081 0.33355 28.2616 0.333374 27.1865V8.81314C0.33355 7.73797 0.680297 6.6915 1.32218 5.82895C1.96406 4.96641 2.86688 4.33374 3.89671 4.02481L13.8967 1.02481ZM22 4.66648C22 4.22445 22.1756 3.80053 22.4882 3.48797C22.8008 3.17541 23.2247 2.99981 23.6667 2.99981H28.6667C29.9928 2.99981 31.2646 3.5266 32.2022 4.46428C33.1399 5.40196 33.6667 6.67373 33.6667 7.99981V9.66648C33.6667 10.1085 33.4911 10.5324 33.1786 10.845C32.866 11.1575 32.4421 11.3331 32 11.3331C31.558 11.3331 31.1341 11.1575 30.8215 10.845C30.509 10.5324 30.3334 10.1085 30.3334 9.66648V7.99981C30.3334 7.55778 30.1578 7.13386 29.8452 6.8213C29.5327 6.50874 29.1087 6.33315 28.6667 6.33315H23.6667C23.2247 6.33315 22.8008 6.15755 22.4882 5.84499C22.1756 5.53243 22 5.10851 22 4.66648ZM32 24.6665C32.4421 24.6665 32.866 24.8421 33.1786 25.1546C33.4911 25.4672 33.6667 25.8911 33.6667 26.3331V27.9998C33.6667 29.3259 33.1399 30.5977 32.2022 31.5353C31.2646 32.473 29.9928 32.9998 28.6667 32.9998H23.6667C23.2247 32.9998 22.8008 32.8242 22.4882 32.5117C22.1756 32.1991 22 31.7752 22 31.3331C22 30.8911 22.1756 30.4672 22.4882 30.1546C22.8008 29.8421 23.2247 29.6665 23.6667 29.6665H28.6667C29.1087 29.6665 29.5327 29.4909 29.8452 29.1783C30.1578 28.8658 30.3334 28.4418 30.3334 27.9998V26.3331C30.3334 25.8911 30.509 25.4672 30.8215 25.1546C31.1341 24.8421 31.558 24.6665 32 24.6665ZM12 16.3331C11.558 16.3331 11.1341 16.5087 10.8215 16.8213C10.509 17.1339 10.3334 17.5578 10.3334 17.9998C10.3334 18.4418 10.509 18.8658 10.8215 19.1783C11.1341 19.4909 11.558 19.6665 12 19.6665H12.0017C12.4437 19.6665 12.8677 19.4909 13.1802 19.1783C13.4928 18.8658 13.6684 18.4418 13.6684 17.9998C13.6684 17.5578 13.4928 17.1339 13.1802 16.8213C12.8677 16.5087 12.4437 16.3331 12.0017 16.3331H12Z"
                    fill="#292D32"
                  />
                  <path
                    d="M32.0001 17.9998L28.6667 21.3332M23.6667 17.9998H32.0001H23.6667ZM32.0001 17.9998L28.6667 14.6665L32.0001 17.9998Z"
                    stroke="#3366FF"
                    stroke-width="3.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default withTranslation()(Welcomegreet);
